/**
 * Legacy controls-strip search — show only in card view.
 * Table view uses double-click column header filters.
 */
export function shouldShowCardsToolbarSearch(viewMode) {
  return viewMode === 'cards';
}

export function wrapControlsStripSearch(viewMode, searchNode) {
  if (!searchNode || !shouldShowCardsToolbarSearch(viewMode)) return null;
  return searchNode;
}
